<template>
  <div class="email-preview-body">
    <div class="comment-detail__header">
      <img
        v-region-img-src="'email-logo-hkland.png'"
        class="hkld-logo"
        alt="Hongkong Land"
      >
      <slot name="recipientsSlot" />
      <div
        class="greeting section-mgn-btm"
        v-if="greeting"
      >
        {{ greeting }}
      </div>
      <slot
        name="additionalInfoSlot"
      />
    </div>
    <div class="consolidated-comment comment-detail__content section-mgn-btm email-preview__content">
      <div
        v-if="description"
        class="comment-content description"
      >
        <div
          v-html="description"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue-demi'

export default {
  props: {
    comments: {
      type: Object,
      default: () => ({}),
    },
    greeting: {
      type: String,
      default: '',
    },
  },
  setup (props) {
    const description = computed(() => {
      return props.comments.description
    })
    return {
      description,
    }
  },
}

</script>

<style lang="scss" scoped>
@import '~styles/email_preview';

.email-preview-body {
  .section-mgn-btm {
    margin-bottom: 24px;
  }

  .recipient-list {
    word-wrap: break-word;
  }
  .small-mgn-right {
    margin-right: 5px;
  }
  .consolidated-comment {
    .comment-content {
      padding: 10px 0;
      font-weight: normal;
    }
  }
  .comment-content {
    text-align: justify;
  }
  .location {
    font-weight: bold;
  }
  .hkld-logo {
    height: 40px;
    margin: 13px 0;
  }

  ::v-deep .consolidated-comment {
    p {
      margin-bottom: 20px;
    }
    .MsoNormal {
      margin-left: 0;
      font-family: Verdana;
      font-size: 14px;
    }
  }
}
</style>
